export { default } from './part-reviews';
